module.exports = __webpack_public_path__ + "stellabio-es2015.d01a0f1939cfea74ca17.worker.js"